import * as React from "react";
import { FieldValues, RegisterOptions } from "react-hook-form";
import { FormTextField, FormTextFieldProps } from "../../FormTextField";
import { useLanguage } from "../../Language";

export interface EmailFieldProps<T>
  extends Omit<FormTextFieldProps<T>, "options"> {
  options?: Omit<RegisterOptions<T>, "valueAsDate" | "valueAsNumber">;
}

export const EmailField = <T extends FieldValues>({
  options,
  label,
  ...props
}: EmailFieldProps<T>) => {
  const { translate } = useLanguage();
  const EMAIL_PATTERN =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const mergedOptions: Partial<RegisterOptions<T>> = {
    ...(options || {}),
    pattern: {
      value: EMAIL_PATTERN,
      message: translate("invalidFormatError", {
        LABEL: label,
      }),
    },
  };

  return (
    <FormTextField<T>
      label={label}
      sx={{ maxWidth: { sm: "320px" } }}
      type="email"
      {...props}
      maxLength={100}
      options={mergedOptions}
    />
  );
};
